export enum TIME_HOURS {
  DAY = 24,
  MONTH = DAY * 30,
  YEAR = MONTH * 12,
}

export enum TIME_DAYS {
  DAY = 1,
  WEEK = 7,
  MONTH = 30,
  YEAR = MONTH * 12,
}

export enum DATE_FORMATS {
  API = 'YYYY-MM-DD',
  API_TIME = 'YYYY-MM-DD HH:mm',
  API_TIME_FULL = 'YYYY-MM-DD HH:mm:ss',
  DAY = 'D',
  DAY_MONTH = 'D MMM',
  DAY_MONTH_YEAR = 'D MMM YYYY',
  DAY_MONTH_YEAR_SHORT = 'D-MM-YY',
  DAY_NAME_COMMA_DAY_MONTH_SHORT = 'dddd, D MMM',
  FILE_TIME_FULL = 'YYYYMMDDHHmmss',
  HOUR = 'HH',
  HOUR_MINUTE_DAY_MONTH_YEAR_SHORT = 'HH:mm @ D/MM/YY',
  MINUTE = 'mm',
  MONTH = 'MMM',
  MONTH_SHORT = 'MM',
  MONTH_YEAR = 'MMM YYYY',
  MONTH_YEAR_SHORT = 'MMM YY',
  TIME = 'HH:mm:ss',
  TIME_SHORT = 'HH:mm',
  YEAR = 'YYYY',
  YEAR_SHORT = 'YY',
}

export const LAST_MINUTE_MINUTES = 60 * 24 - 1;

export enum WEEK_DAYS {
  MONDAY = 0,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
}

export enum TIME_UNIT {
  SECONDS = 'seconds',
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
  YEARS = 'years',
}
